import { useMemo, type ReactNode } from "react";

import { LayoutAncestryContext } from "./LayoutAncestryContext";

export interface LayoutAncestryProviderProps {
  readonly nodeId: number;
  readonly ancestorIds?: readonly number[];
  readonly children: ReactNode;
}

export const LayoutAncestryProvider = ({ nodeId, ancestorIds, children }: LayoutAncestryProviderProps) => {
  const value = useMemo(() => ({ nodeId, ancestorIds }), [nodeId, ancestorIds]);
  return <LayoutAncestryContext value={value}>{children}</LayoutAncestryContext>;
};
